import { PayloadAction } from '@reduxjs/toolkit';
import {
  TApplicationsIdRemoteBankingContacts,
  TRemoteBankingContactsStore,
} from '~/store/remote-banking-contacts/types.ts';

export const contactInformationFormFulfilled = (
  state: TRemoteBankingContactsStore,
  action: PayloadAction<TApplicationsIdRemoteBankingContacts>
) => {
  state.id = action.payload.id;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const contactInformationFormPending = (state: TRemoteBankingContactsStore) => {
  state.loading = true;
  state.id = '';
};
